const computeSearchWhere = (locations, parent) => {
  // array delle località che finiranno nella where della query esapi
  const searchLocations = locations;
  // prima località di quelle selezionate dall'utente,
  // usata per controllarne il livello e da quello impostare la logica corretta
  const [newLocation] = locations;
  const newLocationParent = parent.length ? parent[0] : parent;

  const mainLevels = [4, 6, 9, 118, 130]; // levels che possono avere figli
  const mapLevel = 999;
  // stiamo aggiungendo una singola località o località multiple?
  // località multiple nella ui saranno sempre figlie di una località padre
  const isSingle = locations.length === 1;
  const isMainLevel = mainLevels.indexOf(newLocation.level) > -1 || newLocation.level === mapLevel;

  const uiLocations = {}; // oggetto contenente le località che finiranno nella UI
  if (isMainLevel && isSingle) { // se è mainlevel ed è una singola località
    uiLocations.main = newLocation; // setto come ui.main
    uiLocations.additional = newLocation.has_children ? [] : null;
  } else { // se non è mainlevel o è una scelta multipla
    uiLocations.main = newLocationParent; // setto il parent come ui.main
    uiLocations.additional = locations; // setto la scelta multipla come ui.additional
  }

  return {
    searchLocations,
    searchLocationsParent: newLocationParent || {},
    uiLocations,
  };
};

export default computeSearchWhere;
